import { AppSetting } from 'dependencies/appsettings';
import { TOKEN_KEY, ID_TOKEN_KEY } from 'app/constants';
import { globalVar } from 'app/infrastructure/universal';

interface TokenStorage {
  getItem: (key: string) => string;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
}

class NonPersistedStorage implements TokenStorage {
  private cache: Map<string, string> = new Map();

  public getItem = (key: string) => this.cache.get(key);
  public setItem = (key: string, value: string) => this.cache.set(key, value);
  public removeItem = (key: string) => this.cache.delete(key);
}

class PersistedStorage implements TokenStorage {
  private cache: any = globalVar('localStorage', new NonPersistedStorage());

  public getItem = (key: string) => this.cache.getItem(key);
  public setItem = (key: string, value: string) => this.cache.setItem(key, value);
  public removeItem = (key: string) => this.cache.removeItem(key);
}

const storage: TokenStorage = !!AppSetting.UseLocalStorageTokenCache ?
                                new PersistedStorage() :
                                new NonPersistedStorage();

export const getAccessToken = () => storage.getItem(TOKEN_KEY);

/**
 * The id_token is **only** used for sign-out requests
 */
export const getIdToken = () => storage.getItem(ID_TOKEN_KEY);

export const clearCachedToken = () => {
  storage.removeItem(TOKEN_KEY);
  storage.removeItem(ID_TOKEN_KEY);
};

export const cacheAccessToken = (token: string) => storage.setItem(TOKEN_KEY, token);

/**
 * The id_token is **only** used for sign-out requests
 */
export const cacheIdToken = (token: string) => storage.setItem(ID_TOKEN_KEY, token);

export const hasToken = () => !!getAccessToken();
